document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('mineral');
  if (!root) return;

  const menu = root.querySelector('#menu');
  const updateMenu = () => {
    if (!menu) return;
    menu.classList.toggle('current', window.scrollY > 10);
  };

  updateMenu();
  window.addEventListener('scroll', updateMenu, { passive: true });

  const animatedElements = root.querySelectorAll('.anime');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('active', entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    animatedElements.forEach((element) => observer.observe(element));
  } else {
    animatedElements.forEach((element) => element.classList.add('active'));
  }

  const createDrop = () => {
    const drop = document.createElement('div');
    const image = document.createElement('img');
    image.src = root.dataset.dropImage;
    image.alt = '';
    image.width = 157;
    image.height = 157;
    drop.className = 'drop';
    drop.append(image);
    return drop;
  };

  const setDrop = (drop) => {
    drop.style.left = `${100 * Math.random()}%`;
    drop.style.animationDuration = `${10 * (Math.random() + 1)}s`;
    drop.style.animationDelay = `${6 * Math.random()}s`;
    drop.style.width = `${Math.floor(80 * Math.random() + 10)}px`;
    root.append(drop);

    drop.addEventListener('animationend', () => {
      drop.remove();
      setDrop(createDrop());
    }, { once: true });
  };

  for (let index = 0; index < 5; index += 1) {
    setDrop(createDrop());
  }
});
